import React from 'react';

const HamburgerSvg = () => (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.63641 1H18.3637" stroke="#01172F" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M1.63641 5.36377H14.7273" stroke="#01172F" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M1.63641 9.72705H10.3637" stroke="#01172F" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
)

export default HamburgerSvg;